import { styled } from '@linaria/react';
import { colors } from '@spaceshipapp/cambridge';
import rgba from 'polished/lib/color/rgba';

const { subtext, border, error, surface, brandPrimary, text } = colors;

const calculateBackgroundColor = ({ isError, disabled }: InputWrapperProps) => {
  if (isError) return rgba(error, 0.1);
  if (disabled) return rgba(border, 0.6);
  return surface;
};

interface InputWrapperProps {
  isError?: boolean;
  disabled?: boolean;
}

export const InputWrapper = styled.div<InputWrapperProps>`
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  align-items: center;
  border: solid 1px ${border};
  padding: 0.2rem 0.7rem;
  font-size: 1rem;
  transition: box-shadow 350ms ease;
  background-color: ${calculateBackgroundColor};

  &:focus-within {
    box-shadow: 0 0 0 2px ${brandPrimary};
  }

  &:active:not([disabled]),
  &:active:not(:disabled) {
    box-shadow: 0 0 0 2px ${text};
  }

  &:hover:not(:focus-within) {
    border-color: ${({ disabled }) => (disabled ? border : subtext)};
  }
`;

interface AddonWrapperProps {
  isError?: boolean;
}

export const AddonWrapper = styled.div<AddonWrapperProps>`
  color: ${({ isError }) => (isError ? error : subtext)};
  flex-shrink: 0;
`;
